import { useEffect, useState } from 'react';
import styles from './AIScrapFriendTutorialModal.module.css';
import api from '../../../../../../api';

const AIScrapFriendTutorialModal = ({myHotples, setInfoModalPage, devicePosition}) => {
      const [regionAccount, setRegionAccount] = useState('jeju_hotple_kr_');

      const REGION_INSTAGRAM={
            '강원':'gangwon_hotple_kr',
            '경기':'gyeonggi_hotple_kr',
            '서울':'seoul_hotple_kr',
            '인천':'incheon_hotple_kr',
            '충북':'chungbuk_hotple_kr',
            '세종':'sejong_hotple_kr',
            '충남':'chungnam_hotple_kr_',
            '대전':'daejeon_hotple_kr_',
            '전북':'jeonbuk_hotple_kr',
            '광주':'gwangju_hotple_kr',
            '전남':'jeonnam_hotple_kr',
            '제주':'jeju_hotple_kr_',
            '경북':'gyeongbuk_hotple_kr',
            '대구':'daegu_hotple_kr',
            '경남':'gyeongnam_hotple_kr_',
            '부산':'busan_hotple_kr',
            '울산':'ulsan_hotple_kr',
      }

      const handleGoButtonClick = async () => {
            try {
                alert('맘에 드는 장소 게시글을 찾아, 친구와 함께 @hotple_kr을 태그하면 완료!');

                window.open(`https://instagram.com/${regionAccount}`, '_blank');
            } catch (error) {
                console.error('Error handling go button click:', error);
            }
      };

      async function getRegion(){
            const result = await api.get(`/gis/reverse_geocode`,{
                  params: {
                        lat: devicePosition.lat,
                        long: devicePosition.long
                  }
            });

            if(result){
                  setRegionAccount(REGION_INSTAGRAM[result.data.address.slice(0,2)]);
            }
      }

      useEffect(()=>{
            if(myHotples.hotples.some(myHotple => (!myHotple.taggedBy && myHotple.comment?.includes("@"))))
                  setInfoModalPage(0);

            getRegion();
      },[myHotples]);

      return (
            <div className={styles.container}>
                  <div className={styles.header}>
                        <div className={styles.contents}>
                              <b className={styles.title}>친구 태그 AI 스크랩 튜토리얼</b>
                              <div className={styles.innerContents}>
                                    <div className={styles.description}>
                                          <p className={styles.a}>
                                                <b className={styles.a1}>1. 인스타에서 맘에 드는 장소</b>
                                                <span className={styles.span}> 를 찾아</span>
                                          </p>
                                          <p className={styles.a}>
                                                <b className={styles.a1}>2. 같이 가고 싶은 친구도 함께 태그!</b>
                                          </p>
                                    </div>
                                    <video
                                          className={styles.description1}
                                          src="https://hotple.s3.ap-northeast-2.amazonaws.com/usage/ai_scrap_friend.mp4"
                                          autoPlay 
                                          loop 
                                          muted 
                                          playsInline
                                    />
                                    <div className={styles.dmButton} onClick={() => handleGoButtonClick()}>
                                          <div className={styles.text}>맘에 드는 장소 찾으러가기</div>
                                          <div className={styles.text1}>@{regionAccount}</div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      );
};

export default AIScrapFriendTutorialModal;